import React from 'react';
import * as _ from 'lodash';

import Information from '../../components/modals/common/Information';

import InOutHistoryUserUnregisteredContext from '../../services/inOutHistoryUserUnregistered/InOutHistoryUserUnregisteredContext';

import { messageUtility } from '../../utilities/messageUtility';

import Styles from '../../styles/componentStyle/inOutHistoryUserUnregistered/inOutHistoryUserUnregistered.scss';

export class OperationHeader extends React.Component {
  // 画面表示
  render() {
    return (
      <InOutHistoryUserUnregisteredContext.Consumer>
        {({
          state,
          downloadUnidentifiedLogsCsv,
          updateUnidentifiedLog,
          closeCsvExportErrorDialog,
          closeReflectErrorDialog,
        }) => (
          <div
            className={`${Styles.operationHeader} gate-schedulelist__header`}
          >
            <ul className='btn-menu'>
              <li className='btn-menu__item'>
                <button
                  className={`${
                    state.reflectionUnidentifiedLogList.length < 1
                      ? 'btn-disable'
                      : 'btn-fixedsize--effective'
                  }`}
                  onClick={() => {
                    updateUnidentifiedLog();
                  }}
                  disabled={state.reflectionUnidentifiedLogList.length < 1}
                >
                  {data.buttonTitle.reflectResult}
                </button>
              </li>
              <li className='left-separator btn-menu__item'>
                <button
                  className={`${
                    state.unidentifiedLogs.length < 1
                      ? 'btn-disable'
                      : 'btn--sub'
                  }`}
                  onClick={() => downloadUnidentifiedLogsCsv()}
                  disabled={state.unidentifiedLogs.length < 1}
                >
                  {data.buttonTitle.downloadCsv}
                </button>
              </li>
            </ul>
            <Information
              title={messageUtility.getMessage('E-002-007-02')}
              message={messageUtility.getMessage('E-002-007-03')}
              buttonText={messageUtility.getMessage('I-000-017')}
              visible={state.isCsvExportErrorDialog}
              onClose={() => closeCsvExportErrorDialog()}
              rootClassName={'inline-dialog-md'}
              multilineText
            />
            <Information
              title={messageUtility.getMessage('E-002-001-01')}
              rootClassName={
                state.reflectErrorMessage &&
                state.reflectErrorMessage.length > 28
                  ? 'wide-dialog-md scroll-y'
                  : ''
              }
              multilineText={state.reflectErrorMessage.length > 50}
              message={state.reflectErrorMessage}
              buttonText={messageUtility.getMessage('I-000-008')}
              visible={state.isReflectErrorDialog}
              onClose={() => closeReflectErrorDialog()}
            />
          </div>
        )}
      </InOutHistoryUserUnregisteredContext.Consumer>
    );
  }
}

// 定数
const data = {
  buttonTitle: {
    reflectResult: '実績反映',
    downloadCsv: '表示データをCSV出力',
  },
};



// WEBPACK FOOTER //
// ./src/components/header/InOutHistoryUserUnregisteredHeader.jsx